import React from 'react';
import { 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions,
  Grid,
  Paper,
  Box
} from '@mui/material';
import axios from 'axios';
export default class AnnotationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawing: false,
      startPos: { x: 0, y: 0 },
      selectedBox: null,
      isEditing: false,
      editingControl: null,
      selectedFrameData: null,  
      selectedFrameNumber: null,
      selectedFrameDataOrigin: null,
      selectedFrame: null,
      selectedFrameOrigin: null,
    
      persistentBoxes: [], // Lưu các boxes cố định xuyên suốt video
      userBoxes: new Map(),
    //   annotationMode: 'yolo',
      trackingMode: 'persistent', // 'frame' hoặc 'persistent'
      isEditing: false,      

      loading: false,
      morphologyResult: null,
      error: null,
      isDialogOpen: false
    };
    this.canvasRef = React.createRef();
  }

  handleKeyDown = (e) => {
    if (e.key === 'Delete' || e.key === 'Backspace') {
      this.deleteSelectedBox();
    }
  }

  componentDidMount() {    
    document.addEventListener('keydown', this.handleKeyDown);
    const {
        selectedFrameData,
        selectedFrameDataOrigin,
        selectedFrameNumber,
        selectedFrame,
        selectedFrameOrigin
    } = this.props
    this.setState({
        selectedFrameData,
        selectedFrameDataOrigin,
        selectedFrameNumber,
        selectedFrame,
        selectedFrameOrigin
    })    
  }

  componentWillUnmount() {    
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    // So sánh props hiện tại với props trước đó
    if (this.props.selectedFrameData !== prevProps.selectedFrameData || this.props.selectedFrameNumber !== prevProps.selectedFrameNumber ||
      this.props.selectedFrame !== prevProps.selectedFrame || this.props.selectedFrameOrigin !== prevProps.selectedFrameOrigin || 
      this.props.selectedFrameDataOrigin !== prevProps.selectedFrameDataOrigin
    ) {
    //   console.log(this.props)
      // Thực hiện các hành động khi props thay đổi
      // this.handlePropsChange();
        const {
            selectedFrameData,
            selectedFrameNumber,
            selectedFrame,
            selectedFrameOrigin,
            selectedFrameDataOrigin
        } = this.props
        this.setState({
            selectedFrameData,
            selectedFrameNumber,
            selectedFrame,
            selectedFrameOrigin,
            selectedFrameDataOrigin,
            morphologyResult: null,
        },() => {
            this.drawSelectedFrame();
        }) 
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Chỉ re-render khi cần thiết
    return (
      this.state.selectedFrameData !== nextProps.selectedFrameData ||
      this.state.selectedFrameNumber !== nextProps.selectedFrameNumber ||
      this.state.selectedFrame !== nextProps.selectedFrame ||
      this.state.selectedFrameOrigin !== nextProps.selectedFrameOrigin ||
      this.state.selectedFrameDataOrigin !== nextProps.selectedFrameDataOrigin ||
      
      this.state.morphologyResult !== nextState.morphologyResult
    );
  }  


  drawSelectedFrame = (currentPos = null) => {    
      const ctx = this.canvasRef.current.getContext('2d');
      const {
          selectedFrame,
          selectedFrameNumber,
          selectedFrameData,          
          userBoxes,
          persistentBoxes,
          drawingMode,
          startPos,
          selectedBox,
          trackingMode
      } = this.state;

      if (!selectedFrame) return;

      const frameData = selectedFrame?.get(selectedFrameNumber);      
      if (!selectedFrameData || !this.canvasRef.current) return;

      const image = new Image();
      image.onload = () => {
          this.canvasRef.current.width = image.width;
          this.canvasRef.current.height = image.height;
          ctx.drawImage(image, 0, 0);                  
            
          persistentBoxes.forEach((box, index) =>
                this.drawBox(ctx, box, '#0000ff', index === selectedBox)
            );
     

          // Vẽ box đang vẽ
          if (this.state.isDrawing && currentPos) {
              ctx.strokeStyle = trackingMode === 'persistent' ? '#0000ff' : '#ff0000';
              ctx.lineWidth = 2;
              const width = currentPos.x - startPos.x;
              const height = currentPos.y - startPos.y;
              ctx.strokeRect(startPos.x, startPos.y, width, height);
          }
      };
      image.src = `data:image/jpeg;base64,${frameData.image}`;
  }

  drawExistingBoxes = () => {
    const { selectedFrameNumber, userBoxes } = this.state;    
    const ctx = this.canvasRef.current.getContext('2d');

    // Draw YOLO predictions
    // if (this.state.annotationMode === 'yolo') {
    //   this.state.selectedFrameData.predictions.forEach(pred => {
    //     this.drawBox(ctx, pred, '#00ff00');
    //   });
    // }

    // Draw user boxes
    const frameBoxes = userBoxes.get(selectedFrameNumber) || [];
    frameBoxes.forEach((box, index) => {
      this.drawBox(ctx, box, '#ff0000', index === this.state.selectedBox);
    });
  }

  getClickedControlPoint = (pos) => {
    const { selectedBox, trackingMode, persistentBoxes, userBoxes, selectedFrameNumber } = this.state;
    if (selectedBox === null) return null;

    const boxes = trackingMode === 'persistent' 
      ? persistentBoxes 
      : (userBoxes.get(selectedFrameNumber) || []);
    
    const box = boxes[selectedBox];
    if (!box) return null;

    const controlPoints = [
      { x: box.x, y: box.y, type: 'tl' },
      { x: box.x + box.width, y: box.y, type: 'tr' },
      { x: box.x + box.width, y: box.y + box.height, type: 'br' },
      { x: box.x, y: box.y + box.height, type: 'bl' }
    ];

    const threshold = 5;
    return controlPoints.find(point => 
      Math.abs(point.x - pos.x) < threshold && 
      Math.abs(point.y - pos.y) < threshold
    );
  }

  getMousePos = (e) => {
    const rect = this.canvasRef.current.getBoundingClientRect();
    const scaleX = this.canvasRef.current.width / rect.width;
    const scaleY = this.canvasRef.current.height / rect.height;
    
    return {
      x: (e.clientX - rect.left) * scaleX,
      y: (e.clientY - rect.top) * scaleY
    };
  }

  handleMouseDown = (e) => {        
    const pos = this.getMousePos(e);
    const controlPoint = this.getClickedControlPoint(pos);

    if (controlPoint) {
      this.setState({
        isEditing: true,
        editingControl: controlPoint
      });
      return;
    }

    this.setState({
      isDrawing: true,
      startPos: pos
    });
  }

  handleMouseMove = (e) => {
    if (!this.state.isDrawing && !this.state.isEditing) return;        

    const pos = this.getMousePos(e);
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    this.drawSelectedFrame();

    if (this.state.isDrawing) {
      this.drawPreviewBox(ctx, pos);
    } else if (this.state.isEditing && this.state.editingControl) {
      const {
        selectedBox,
        editingControl,
        startPos
      } = this.state
      // this.handleBoxEditing(ctx, pos);

      // Xử lý chỉnh sửa box
      const boxes = this.state.persistentBoxes        
      
      const oldBox = boxes[selectedBox];
      if (!oldBox) return;

      // Tính toán kích thước và vị trí mới dựa trên control point đang kéo
      let newBox = { ...oldBox };

      switch (editingControl.type) {
        case 'tl': // top-left
          newBox = {
            ...newBox,
            x: pos.x,
            y: pos.y,
            width: oldBox.x + oldBox.width - pos.x,
            height: oldBox.y + oldBox.height - pos.y
          };
          break;
        case 'tr': // top-right
          newBox = {
            ...newBox,
            y: pos.y,
            width: pos.x - oldBox.x,
            height: oldBox.y + oldBox.height - pos.y
          };
          break;
        case 'bl': // bottom-left
          newBox = {
            ...newBox,
            x: pos.x,
            width: oldBox.x + oldBox.width - pos.x,
            height: pos.y - oldBox.y
          };
          break;
        case 'br': // bottom-right
          newBox = {
            ...newBox,
            width: pos.x - oldBox.x,
            height: pos.y - oldBox.y
          };
          break;
        case 'move': // Di chuyển cả box
          const dx = pos.x - startPos.x;
          const dy = pos.y - startPos.y;
          newBox = {
            ...newBox,
            x: oldBox.x + dx,
            y: oldBox.y + dy
          };
          break;
      }

      // Vẽ preview box đang chỉnh sửa
      ctx.strokeStyle = '#ffff00';
      ctx.lineWidth = 2;
      ctx.setLineDash([5, 5]);
      ctx.strokeRect(newBox.x, newBox.y, newBox.width, newBox.height);
      ctx.setLineDash([]);

      // Hiển thị kích thước mới
      ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
      ctx.font = '12px Arial';
      const dimensions = `${Math.abs(Math.round(newBox.width))}x${Math.abs(Math.round(newBox.height))}`;
      ctx.fillText(dimensions, newBox.x, newBox.y - 5);

      // Vẽ control points tạm thời
      this.drawControlPoints(ctx, newBox.x, newBox.y, newBox.width, newBox.height);

    }
  }

  handleMouseUp = (e) => {
    if (!this.state.isDrawing && !this.state.isEditing) return;

    const pos = this.getMousePos(e);
    
    if (this.state.isDrawing) {
      this.handleDrawingComplete(pos);
    } else if (this.state.isEditing) {
      // this.handleEditingComplete(pos);
      
      // Xử lý chỉnh sửa box
      const {
        selectedBox,
        editingControl,
        startPos
      } = this.state

      const boxes = this.state.persistentBoxes         
      
      const oldBox = boxes[selectedBox];
      if (!oldBox) return;
  
      let updatedBox = { ...oldBox };
  
      // Tính toán vị trí mới dựa trên control point được kéo
      switch (editingControl.type) {
        case 'tl': // top-left
          updatedBox.width += (oldBox.x - pos.x);
          updatedBox.height += (oldBox.y - pos.y);
          updatedBox.x = pos.x;
          updatedBox.y = pos.y;
          break;
        case 'tr': // top-right
          updatedBox.width = pos.x - oldBox.x;
          updatedBox.height += (oldBox.y - pos.y);
          updatedBox.y = pos.y;
          break;
        case 'bl': // bottom-left
          updatedBox.width += (oldBox.x - pos.x);
          updatedBox.height = pos.y - oldBox.y;
          updatedBox.x = pos.x;
          break;
        case 'br': // bottom-right
          updatedBox.width = pos.x - oldBox.x;
          updatedBox.height = pos.y - oldBox.y;
          break;
      }
  
      // Đảm bảo kích thước box không âm
      if (updatedBox.width < 5 || updatedBox.height < 5) {
        this.setState({
          isEditing: false,
          editingControl: null
        }, () => this.drawSelectedFrame());
        return;
      }
  
      // Cập nhật state với box đã chỉnh sửa      
      this.setState(prevState => {
        const newPersistentBoxes = [...prevState.persistentBoxes];
        newPersistentBoxes[selectedBox] = updatedBox;
        return {
          persistentBoxes: newPersistentBoxes,
          isEditing: false,
          editingControl: null
        };
      }, () => this.drawSelectedFrame());
    }
  }

//   drawCurrentFrame = (currentPos = null) => {
//     const canvas = this.canvasRef.current;
//     if (!canvas) return;

//     const ctx = canvas.getContext('2d');
//     const { 
//       currentFrame, 
//       frames, 
//       userBoxes, 
//       persistentBoxes,
//       drawingMode, 
//       startPos, 
//       selectedBox,
//       trackingMode 
//     } = this.state;
    
//     const frameData = frames.get(currentFrame);
//     if (!frameData) return;

//     const image = new Image();
//     image.onload = () => {
//       canvas.width = image.width;
//       canvas.height = image.height;
//       ctx.drawImage(image, 0, 0);

//       // Vẽ YOLO predictions
//       if (drawingMode === 'yolo') {
//         frameData.predictions.forEach(pred => this.drawBox(ctx, pred, '#00ff00'));
//       }

//       // Vẽ frame-specific boxes nếu đang ở frame mode
//       if (trackingMode === 'frame') {
//         const frameUserBoxes = userBoxes.get(currentFrame) || [];
//         frameUserBoxes.forEach((box, index) => 
//           this.drawBox(ctx, box, '#ff0000', index === selectedBox)
//         );
//       }

//       // Vẽ persistent boxes
//       if (trackingMode === 'persistent') {
//         persistentBoxes.forEach((box, index) => 
//           this.drawBox(ctx, box, '#0000ff', index === selectedBox)
//         );
//       }

//       // Vẽ box đang vẽ
//       if (this.state.isDrawing && currentPos) {
//         ctx.strokeStyle = trackingMode === 'persistent' ? '#0000ff' : '#ff0000';
//         ctx.lineWidth = 2;
//         const width = currentPos.x - startPos.x;
//         const height = currentPos.y - startPos.y;
//         ctx.strokeRect(startPos.x, startPos.y, width, height);
//       }
//     };
//     image.src = `data:image/jpeg;base64,${frameData.image}`;
//   }

  drawBox = (ctx, box, color, isSelected = false) => {
    const { x, y, width, height, label, confidence } = box;

    ctx.strokeStyle = isSelected ? '#ffff00' : color;
    ctx.lineWidth = isSelected ? 3 : 2;
    ctx.strokeRect(x, y, width, height);

    if (isSelected) {
      this.drawControlPoints(ctx, x, y, width, height);
    }

    // const text = `${label} ${Math.round(confidence * 100)}%`;
    // const labelWidth = ctx.measureText(text).width;
    
    // ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
    // ctx.fillRect(x, y - 20, labelWidth + 10, 20);
    
    // ctx.fillStyle = isSelected ? '#ffff00' : color;
    // ctx.font = '16px Arial';
    // ctx.fillText(text, x + 5, y - 5);
  }

  drawControlPoints = (ctx, x, y, width, height) => {
    const points = [
      { x, y }, // top-left
      { x: x + width, y }, // top-right
      { x: x + width, y: y + height }, // bottom-right
      { x, y: y + height } // bottom-left
    ];

    points.forEach(point => {
      ctx.fillStyle = '#ffff00';
      ctx.beginPath();
      ctx.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      ctx.fill();
    });
  }

  drawPreviewBox = (ctx, currentPos) => {
    const { startPos } = this.state;
    const { trackingMode } = this.props;

    ctx.strokeStyle = trackingMode === 'persistent' ? '#0000ff' : '#ff0000';
    ctx.lineWidth = 2;
    ctx.setLineDash([5, 5]);
    
    const width = currentPos.x - startPos.x;
    const height = currentPos.y - startPos.y;
    ctx.strokeRect(startPos.x, startPos.y, width, height);
    ctx.setLineDash([]);

    // Show dimensions
    ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
    ctx.font = '12px Arial';
    const dimensions = `${Math.abs(Math.round(width))}x${Math.abs(Math.round(height))}`;
    ctx.fillText(dimensions, startPos.x, startPos.y - 5);
  }
  
  handleDrawingComplete = (pos) => {
    const { startPos, trackingMode } = this.state;
    const newBox = {
      x: Math.min(startPos.x, pos.x),
      y: Math.min(startPos.y, pos.y),
      width: Math.abs(pos.x - startPos.x),
      height: Math.abs(pos.y - startPos.y),
      // label: 'Custom',
      // confidence: 1.0
    };

    if (newBox.width > 5 && newBox.height > 5) {
      if (trackingMode === 'persistent') {
        this.onAddPersistentBox(newBox);
      } else {
        this.onAddFrameBox(newBox);
      }
    }

    this.setState({
      isDrawing: false
    }, () => this.drawSelectedFrame());
    
  }

  onAddPersistentBox = (newBox) => {
    this.setState(prevState => ({
      persistentBoxes: [...prevState.persistentBoxes, newBox],
      selectedBox: prevState.persistentBoxes.length
    }), () => this.drawSelectedFrame());
  }
  
  onAddFrameBox = (newBox) => {
    const selectedFrameNumber = this.state.selectedFrameNumber;
    this.setState(prevState => {
      const newUserBoxes = new Map(prevState.userBoxes);
      const frameBoxes = newUserBoxes.get(selectedFrameNumber) || [];
      newUserBoxes.set(selectedFrameNumber, [...frameBoxes, newBox]);
      
      return {
        userBoxes: newUserBoxes,
        selectedBox: frameBoxes.length
      };
    }, () => this.drawSelectedFrame());
  }

  handleBoxClick = (e) => {    
    const pos = this.getMousePos(e);
    const { selectedFrameNumber, userBoxes, persistentBoxes, trackingMode } = this.state;

    let clickedBoxIndex = -1;
    
    clickedBoxIndex = persistentBoxes.findIndex(box => 
        pos.x >= box.x && 
        pos.x <= box.x + box.width &&
        pos.y >= box.y && 
        pos.y <= box.y + box.height
      );
    

    this.setState({ selectedBox: clickedBoxIndex },() => {
        this.drawSelectedFrame();
    });    
  }

  deleteSelectedBox = () => {
    const { selectedBox } = this.state;
    if (selectedBox === null) return;

    this.setState(prevState => ({
        persistentBoxes: prevState.persistentBoxes.filter((_, i) => i !== selectedBox),
        selectedBox: null
      }),() => {
        this.drawSelectedFrame();
      });    
  }

  deleteBox = (index) => {
    // const { trackingMode, selectedFrameNumber } = this.state;

    this.setState(prevState => ({
        persistentBoxes: prevState.persistentBoxes.filter((_, i) => i !== index),
        selectedBox: null
      }), () => this.drawSelectedFrame());

  
    // if (trackingMode === 'persistent') {
    //   this.setState(prevState => ({
    //     persistentBoxes: prevState.persistentBoxes.filter((_, i) => i !== index),
    //     selectedBox: null
    //   }), () => this.drawSelectedFrame());
    // } else {
    //   this.setState(prevState => {
    //     const newUserBoxes = new Map(prevState.userBoxes);
    //     const frameBoxes = newUserBoxes.get(selectedFrameNumber) || [];
    //     const updatedBoxes = frameBoxes.filter((_, i) => i !== index);
        
    //     if (updatedBoxes.length === 0) {
    //       newUserBoxes.delete(selectedFrameNumber);
    //     } else {
    //       newUserBoxes.set(selectedFrameNumber, updatedBoxes);
    //     }
  
    //     return {
    //       userBoxes: newUserBoxes,
    //       selectedBox: null
    //     };
    //   }, () => this.drawSelectedFrame());
    // }
  }

  // Thêm methods để control dialog
handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };
  
  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false });
  };

handleSubmit = async () => {
    try {
        const { persistentBoxes, selectedFrameDataOrigin } = this.state;
        if (!persistentBoxes.length) {
            alert('Please draw boxes first');
            return;
        }

        this.setState({ loading: true }, async () => {
            //   const canvas = this.canvasRef.current;
            // const imageData = canvas.toDataURL('image/png').split(',')[1];
            const imageData = `${selectedFrameDataOrigin?.image}`;

            const formData = new FormData();
            formData.append('image', imageData);
            formData.append('boxes', JSON.stringify(persistentBoxes));

            const response = await axios.post('https://sperms.ailab.vn:5008/segment-image/', formData);
            // console.log(response.data)
            this.setState({
                morphologyResult: response.data,
                loading: false,
                isDialogOpen: true  // Mở dialog khi có kết quả
            });
        });
    } catch (error) {
        console.log(error)
        this.setState({
            error: error.message,
            loading: false
        });
    }
}

// Thêm component ResultDialog
renderResultDialog = () => {
    const { isDialogOpen, morphologyResult } = this.state;
  
    if (!morphologyResult) return null;
  
    return (
      <Dialog 
        open={isDialogOpen} 
        onClose={this.handleCloseDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Kết quả Hình thái học</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <h3 className="font-bold mb-2">Mask</h3>
                <img 
                  src={`data:image/png;base64,${morphologyResult.mask}`}
                  alt="Mask" 
                  style={{ width: '100%', height: 'auto' }} 
                />
              </Paper>
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <h3 className="font-bold mb-2">Masked Image</h3>
                <img 
                  src={`data:image/png;base64,${morphologyResult.masked_image}`}
                  alt="Masked" 
                  style={{ width: '200%', height: 'auto' }} 
                />
              </Paper>
            </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog} color="primary">
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { loading, selectedFrameNumber, trackingMode, persistentBoxes, userBoxes, morphologyResult } = this.state;        
    const currentBoxes = trackingMode === 'persistent' 
    ? persistentBoxes 
    : (userBoxes.get(selectedFrameNumber) || []);

    return (
      <div className="annotation-panel" style={{ width: '50%', paddingLeft: "10px" }}>        
      {(!loading && morphologyResult !== null) && (
        <img
            src={`data:image/png;base64,${morphologyResult.mask}`}
            alt="Mask"
            // style={{ width: '200%', height: 'auto' }}
            className="w-full border border-gray-300"
        />
      )}
      {(!loading && morphologyResult === null) && (
        <canvas
          ref={this.canvasRef}
          className="w-full border border-gray-300"
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseUp}
          onClick={this.handleBoxClick}
        />
      )}        

            <div className="absolute bottom-4 left-4 space-x-2">
                <div className="mb-4 flex justify-between items-center">
                    <Button
                        variant="contained"
                        onClick={this.handleSubmit}
                        className="px-4 py-2 bg-blue-500 text-white rounded"
                    >
                        Xác nhận
                    </Button>
                    {/* <Button
                        variant="contained"
                        // onClick={this.captureFrame}
                        // onClick={() => {
                        //     console.log(persistentBoxes)
                        //     // this.handleSubmit()
                        // }}
                        onClick={this.handleSubmit}
                        disabled={loading}
                        className="ml-2 px-4 py-2 bg-blue-500 text-white rounded"
                    >
                        {loading ? 'Đang xử lý...' : 'Hình thái học'}
                    </Button> */}
                    {/* <span className="text-sm text-gray-500">
                        {selectedFrameNumber !== null ? `Frame #${selectedFrameNumber}` : ''}
                    </span> */}
                    <br/>
                    {/* <Button
                        style={{marginTop: "10px"}}
                        variant="contained"
                        onClick={this.deleteSelectedBox}
                        disabled={this.state.selectedBox === null}
                        className={`px-4 py-2 ${this.state.selectedBox !== null ? 'bg-red-500' : 'bg-gray-500'} text-white rounded`}
                    >
                        Xóa Box đang chọn
                    </Button> */}
                </div>


                {/* <div className="w-80 p-4 border-l border-gray-200">
                    <div className="mb-4">
                        <h3 className="text-lg font-medium">
                            {trackingMode === 'persistent' ? 'Persistent' : 'Frame'} Bounding Boxes
                        </h3>
                        <p className="text-sm text-gray-500">
                            {currentBoxes.length} boxes
                        </p>
                    </div>

                    <div className="space-y-2 max-h-[600px] overflow-y-auto">
                        {currentBoxes.map((box, index) => (
                            <div
                                key={index}
                                className={`p-3 rounded border ${selectedBox === index
                                    ? 'border-yellow-500 bg-yellow-50'
                                    : 'border-gray-200'
                                    }`}
                                onClick={() => this.handleBoxSelect(index)}
                            >
                                <div className="flex justify-between items-center mb-2">
                                    <span className="font-medium">Box {index + 1}</span>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.deleteBox(index);
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                                <div className="text-sm text-gray-600">
                                    <div>Position: ({Math.round(box.x)}, {Math.round(box.y)})</div>
                                    <div>Size: {Math.round(box.width)}x{Math.round(box.height)}</div>
                                    <div>Label: {box.label}</div>
                                    <div>Confidence: {Math.round(box.confidence * 100)}%</div>
                                </div>
                            </div>
                        ))}

                        {currentBoxes.length === 0 && (
                            <div className="text-center text-gray-500 py-4">
                                No bounding boxes
                            </div>
                        )}
                    </div>
                </div> */}
        </div>
        {/* Render Result Dialog */}
            {/* {this.renderResultDialog()} */}
      </div>
    );
  }
}